"use client";
import { useEffect, useState } from "react";
import FooterLink from "./FooterLink";
import Navlink from "../../General Components/Navlink";
import IconLink from "../../General Components/IconLink";

interface FooterItem {
  id: number;
  name: string;
}

const Footer = () => {
  const [projects, setProjects] = useState<FooterItem[]>([]);
  const [games, setGames] = useState<FooterItem[]>([]);

  useEffect(() => {
    fetch("/api/footer")
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (data) {
          setProjects(data.projects);
          setGames(data.games);
        }
      })
      .catch(() => {});
  }, []);

  return (
    <div className="footer" style={{ marginLeft: "4%", marginRight: "4%", marginTop: "20%", paddingBottom: "6%" }}>
      <div className="grid grid-cols-2 sm:flex sm:justify-evenly gap-y-6 w-full mt-7">
        <div className="flex flex-col items-start">
          <FooterLink link="/" className="mt-2 text-lg! text-start!">
            CODY-TAYLOR.COM
          </FooterLink>
          <Navlink link="/contact" className="py-0.5! text-start!">
            Contact Me!
          </Navlink>
        </div>
        <div className="flex flex-col items-start">
          <FooterLink link="/projects" className="mt-2 text-lg! text-start!">
            PROJECTS
          </FooterLink>
          {projects.map((p) => (
            <Navlink key={p.id} link={`/projects#project-${p.id}`} className="py-0.5! text-start!">
              {p.name}
            </Navlink>
          ))}
        </div>
        <div className="flex flex-col items-start">
          <FooterLink link="/games" className="mt-2 text-lg!">
            GAMES
          </FooterLink>
          {games.map((g) => (
            <Navlink key={g.id} link={`/games#game-${g.id}`} className="py-0.5! text-start!">
              {g.name}
            </Navlink>
          ))}
        </div>
        <div className="flex flex-col items-start">
          <FooterLink link="/contact" className="mt-2 text-lg!">
            SOCIALS
          </FooterLink>
          <div>
            <IconLink
              link="https://github.com/Codster177"
              image="/Icons/Websites/Github-Icon.svg"
              imgClassName="flex-none h-9"
              imgWidth={36}
              imgHeight={36}
            />
            <IconLink
              link="https://codster177.itch.io"
              image="/Icons/Websites/Itch-Icon.svg"
              imgClassName="flex-none h-9"
              imgWidth={36}
              imgHeight={36}
            />
            <IconLink
              link="https://www.linkedin.com/in/cody-taylor-36a6aa24b/"
              image="/Icons/Websites/LinkedIn_icon.svg"
              imgClassName="flex-none h-9"
              imgWidth={36}
              imgHeight={36}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
